import { useState } from "react";
import clsx from "clsx";
import type { BookingLocale } from "@/i18n/types";
import type { BookingLegalContext, BookingLegalDocument } from "@/lib/bookingLegalTexts";
import { BookingLegalModal } from "@/components/BookingLegalModal";

type BookingTermsAcceptanceProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  locale: BookingLocale;
  legalContext: BookingLegalContext;
  termsPrefix: string;
  termsAnd: string;
  termsSuffix: string;
  termsLink: string;
  privacyLink: string;
  closeLabel: string;
  /** Hebt die Box hervor, wenn die Zustimmung beim Weiterklick fehlt. */
  missing?: boolean;
};

export function BookingTermsAcceptance({
  checked,
  onChange,
  locale,
  legalContext,
  termsPrefix,
  termsAnd,
  termsSuffix,
  termsLink,
  privacyLink,
  closeLabel,
  missing = false,
}: BookingTermsAcceptanceProps) {
  const [openDocument, setOpenDocument] = useState<BookingLegalDocument | null>(null);

  return (
    <>
      <div
        className={clsx(
          "rounded-xl border p-4 transition-colors",
          missing && !checked
            ? "border-[#e8b15a] bg-[#fffaf2]"
            : checked
              ? "border-brand-200 bg-brand-50/60"
              : "border-slate-200 bg-slate-50/80",
        )}
        data-missing-field={missing && !checked ? "true" : undefined}
      >
        <label className="flex cursor-pointer items-start gap-3">
          <input
            type="checkbox"
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
            className="mt-0.5 h-5 w-5 shrink-0 rounded border-slate-300 text-brand-600 focus:ring-brand-500/30"
          />
          <span className="text-sm leading-relaxed text-slate-700">
            {termsPrefix}{" "}
            <button
              type="button"
              className="font-medium text-brand-700 underline decoration-brand-300 underline-offset-2 hover:text-brand-800"
              onClick={(event) => {
                event.preventDefault();
                setOpenDocument("terms");
              }}
            >
              {termsLink}
            </button>{" "}
            {termsAnd}{" "}
            <button
              type="button"
              className="font-medium text-brand-700 underline decoration-brand-300 underline-offset-2 hover:text-brand-800"
              onClick={(event) => {
                event.preventDefault();
                setOpenDocument("privacy");
              }}
            >
              {privacyLink}
            </button>{" "}
            {termsSuffix}
          </span>
        </label>
        <div className="mt-3 flex flex-wrap gap-2 pl-8">
          <button
            type="button"
            className="bk-btn-secondary px-3 py-1.5 text-xs"
            onClick={() => setOpenDocument("terms")}
          >
            {termsLink}
          </button>
          <button
            type="button"
            className="bk-btn-secondary px-3 py-1.5 text-xs"
            onClick={() => setOpenDocument("privacy")}
          >
            {privacyLink}
          </button>
        </div>
      </div>

      <BookingLegalModal
        open={openDocument === "terms"}
        legalDocument="terms"
        locale={locale}
        closeLabel={closeLabel}
        legalContext={legalContext}
        onClose={() => setOpenDocument(null)}
      />
      <BookingLegalModal
        open={openDocument === "privacy"}
        legalDocument="privacy"
        locale={locale}
        closeLabel={closeLabel}
        legalContext={legalContext}
        onClose={() => setOpenDocument(null)}
      />
    </>
  );
}
